/**
 * RTK Query endpoints — Resources
 *
 * Migrated from: src/pages/resources/actions.js
 *
 * Usage:
 *   import { useResourceListQuery, useCreateResourceMutation } from '../../services/api/resourceApi';
 *
 *   const { data, isLoading, isError } = useResourceListQuery({ filters: { name: 'X' } });
 *   const [createResource, { isLoading: isCreating }] = useCreateResourceMutation();
 */

import { baseApi } from './baseApi';
import { buildQueryString } from './utils';

const resourceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /su/resource
    resourceList: builder.query({
      query: (params = {}) => ({
        url: `/su/resource${buildQueryString(params)}`,
        method: 'GET',
      }),
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map(({ id }) => ({ type: 'Resource', id })),
              { type: 'Resource', id: 'LIST' },
            ]
          : [{ type: 'Resource', id: 'LIST' }],
    }),

    // POST /su/resource
    createResource: builder.mutation({
      query: (data) => ({
        url: '/su/resource',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Resource', id: 'LIST' }],
    }),

    // PUT /su/resource/:id/edit
    editResource: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/su/resource/${id}/edit`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Resource', id },
        { type: 'Resource', id: 'LIST' },
      ],
    }),

    // POST /su/resource/:id/delete
    deleteResource: builder.mutation({
      query: (id) => ({
        url: `/su/resource/${id}/delete`,
        method: 'POST',
        body: {},
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'Resource', id },
        { type: 'Resource', id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useResourceListQuery,
  useCreateResourceMutation,
  useEditResourceMutation,
  useDeleteResourceMutation,
} = resourceApi;

export default resourceApi;
